module.exports = "//public.getcloudapp.com/packs/media/images/icons-add-to-collection-solid-8179c7656991cf1bafa36b00561d40b3.svg";